export const modifiers = {
    minted: 'minted',
    mintedMinimal: 'mintedMinimal',
    mintedMore: 'mintedMore',
};
export const viewBoxSizes = {
    [modifiers.minted]: '0 0 130 32',
    [modifiers.mintedMinimal]: '0 0 38 25',
    [modifiers.mintedMore]: '0 0 228 32',
};
